"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.buttonVariants = exports.Button = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const React = __importStar(require("react"));
const react_slot_1 = require("@radix-ui/react-slot");
const class_variance_authority_1 = require("class-variance-authority");
const utils_1 = require("../lib/utils");
const buttonVariants = (0, class_variance_authority_1.cva)("inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&_svg]:pointer-events-none [&_svg]:size-4 [&_svg]:shrink-0", {
    variants: {
        variant: {
            default: "bg-primary text-primary-foreground shadow hover:bg-primary/90",
            destructive: "bg-destructive text-destructive-foreground shadow-sm hover:bg-destructive/90",
            outline: "border border-input shadow-sm hover:bg-accent hover:text-accent-foreground",
            secondary: "bg-secondary text-secondary-foreground shadow-sm hover:bg-secondary/80",
            ghost: "hover:bg-accent hover:text-accent-foreground",
            link: "text-primary underline-offset-4 hover:underline",
            // ─── Admin dashboard variants (backend/src/components/ui/button.tsx) ───
            "admin-default": "bg-primary text-primary-foreground focus-visible:ring-2 hover:bg-blue-700",
            "admin-secondary": "bg-white text-slate-900 border border-border focus-visible:ring-2 hover:bg-slate-100",
            "admin-ghost": "text-slate-600 focus-visible:ring-2 hover:bg-slate-100 hover:text-slate-900",
            "admin-destructive": "bg-red-600 text-white focus-visible:ring-2 hover:bg-red-700",
            "warm-primary": "rounded-full bg-warm-accent text-white font-semibold shadow-[0_2px_12px_rgba(37,99,235,.25)] hover:bg-blue-700 hover:-translate-y-px hover:shadow-[0_6px_20px_rgba(37,99,235,.35)] transition-all",
            "warm-outline": "rounded-full border-[1.5px] border-warm-border bg-transparent text-warm-ink font-medium hover:border-warm-accent hover:text-warm-accent transition-colors",
            "warm-secondary": "rounded-full bg-warm-ink text-white font-semibold hover:bg-slate-800 transition-colors",
            "warm-ghost": "rounded-full bg-transparent text-warm-ink2 font-medium hover:bg-warm-bg2 transition-colors",
            "warm-white": "rounded-full bg-white text-warm-accent font-bold hover:-translate-y-0.5 hover:shadow-[0_8px_24px_rgba(0,0,0,.15)] transition-all",
        },
        size: {
            default: "h-9 px-4 py-2",
            sm: "h-8 rounded-md px-3 text-xs",
            lg: "h-10 rounded-md px-8",
            icon: "h-9 w-9",
            // ─── Admin dashboard sizes (backend/src/components/ui/button.tsx) ───
            "admin-sm": "h-9 rounded-md px-3",
            "admin-lg": "h-11 rounded-md px-8",
            "warm-sm": "h-9 px-4 text-[.78rem]",
            "warm-md": "h-10 px-5",
            "warm-lg": "h-12 px-7",
            "warm-hero": "h-[52px] px-8 text-base",
        },
    },
    defaultVariants: {
        variant: "default",
        size: "default",
    },
});
exports.buttonVariants = buttonVariants;
const Button = React.forwardRef(({ className, variant, size, asChild = false, ...props }, ref) => {
    const Comp = asChild ? react_slot_1.Slot : "button";
    return ((0, jsx_runtime_1.jsx)(Comp, { className: (0, utils_1.cn)(buttonVariants({ variant, size, className })), ref: ref, ...props }));
});
exports.Button = Button;
Button.displayName = "Button";
